import { useEffect, useState } from 'react'
import clsx from 'clsx'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

import { TApi } from '../../../../shared/const'
import http from '../../../../shared/http'

import Btn from '../../../../UI/Btn'
import Loading from '../../../../UI/Loading'
import { PlainTextarea } from '../../../../UI/PlainField'

import styles from './style.module.scss'
import { formatDateTime } from '../../../../shared/datetime'

/**
 * Reiter „Notizen & Verlauf" im eigenen Profil.
 *
 * Hier steht, was die Person selbst festhält, und was die Administration ihr
 * ausdrücklich freigegeben hat. Die automatisch mitgeschriebenen Ereignisse
 * (Statuswechsel, Anfragen, geänderte Rollen) bleiben in der Verwaltung — sie
 * sind eine Prüfspur und keine Mitteilung; was diese Person betrifft, steht in
 * „Meine Junior Companies" und im Unterstützungsbedarf.
 */
export default function SupporterNotes() {
	const { t } = useTranslation()

	const [entries, setEntries] = useState(null)
	const [message, setMessage] = useState('')
	const [isSaving, setSaving] = useState(false)

	const load = () =>
		http
			.get(TApi.SUPPORTER_LOG)
			.then(({ data }) => setEntries(data))
			.catch(() => setEntries([])) // Meldung kommt aus shared/http

	useEffect(() => {
		load()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const submit = () => {
		const text = message.trim()
		if (!text) return

		setSaving(true)
		http.post(TApi.SUPPORTER_LOG, { message: text })
			.then(() => {
				setMessage('')
				toast.success(t('Entry saved'))
				return load()
			})
			.catch(() => {}) // Meldung kommt aus shared/http
			.finally(() => setSaving(false))
	}

	return (
		<>
			<p className={styles.notesIntro}>{t('supporterOwnNotesHint')}</p>

			<PlainTextarea
				rows={4}
				label={t('newLogEntry')}
				placeholder={t('supporterOwnNotePlaceholder')}
				value={message}
				onChange={e => setMessage(e.target.value)}
			/>

			<div className={styles.footer}>
				<Btn loading={isSaving} disabled={!message.trim()} onClick={submit}>
					{t('save')}
				</Btn>
			</div>

			{entries === null && <Loading />}
			{entries?.length === 0 && <p className={styles.hint}>{t('noLogEntriesYet')}</p>}
			{!!entries?.length && (
				<ul className={styles.noteList}>
					{entries.map(entry => (
						<li key={entry.id} className={styles.noteRow}>
							<div className={styles.noteHead}>
								<span
									className={clsx(
										styles.noteAuthor,
										entry.authorRole !== 'SUPPORTER' && styles.noteAuthorAdmin
									)}
								>
									{t(entry.authorRole === 'SUPPORTER' ? 'noteByMe' : 'noteByAdmin')}
								</span>
								<span className={styles.noteMeta}>
									{formatDateTime(entry.createdAt, {
										day: '2-digit',
										month: '2-digit',
										year: 'numeric',
										hour: '2-digit',
										minute: '2-digit'
									})}
									{entry.authorName && ` · ${entry.authorName}`}
								</span>
							</div>
							<p className={styles.noteText}>{entry.message}</p>
						</li>
					))}
				</ul>
			)}
		</>
	)
}
